<template>
  <div id="shopping-tools-tiles" class="sokal-py-4 sokal-pt-0">
    <div class="sokal-modern-styles">
        <div class="sokal-container">
            <div class="sokal-vertical-space">
                <div class="sokal-space-y-2"></div>
            </div>
              <div class="sokal-my-1 sokal-mx-1">
                <p class="shopping-tools-super-title">Explore</p>
                <h2 class="shopping-tools-title sokal-mt-0">Hometown Shopping Tools</h2>
              </div>
              <div class="row row-no-gutters">
                  <div class="col-xs-12">
                      <div
                          class="sokal-grid">
                          <!-- Card -->
                          <a href="#"
                              class="sokal-card sokal-inline-flex sokal-w-auto has-border-radius lazyload sokal-relative grid-1"
                              :style="{ backgroundImage: `url('https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/354/original/inventory.png?1763656691')` }">
                              <div class="sokal-bg-cover"></div>
                              <div
                                  class="sokal-inline-flex sokal-items-start sokal-justify-end sokal-flex-col text-left">
                                  <div class="sokal-card-content sokal-color-light">
                                      <p class="h2 sokal-m-0">Schedule Service</p>
                                  </div>
                              </div>
                          </a>
                          <!-- Card -->
                          <a href="#"
                              class="sokal-card sokal-inline-flex sokal-w-auto has-border-radius lazyload sokal-relative grid-2"
                              :style="{ backgroundImage: `url('https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/356/original/trade.png?1763656692')` }">
                              <div class="sokal-bg-cover"></div>
                              <div
                                  class="sokal-inline-flex sokal-items-start sokal-justify-end sokal-flex-col text-left">
                                  <div class="sokal-card-content sokal-color-light">
                                      <p class="h2 sokal-m-0">Value Your Trade</p>
                                  </div>
                              </div>
                          </a>
                          <!-- Card -->
                          <a href="#"
                              class="sokal-card sokal-inline-flex sokal-w-auto has-border-radius lazyload sokal-relative grid-3"
                              :style="{ backgroundImage: `url('https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/355/original/service.png?1763656692')` }">
                              <div class="sokal-bg-cover"></div>
                              <div
                                  class="sokal-inline-flex sokal-items-start sokal-justify-end sokal-flex-col text-left">
                                  <div class="sokal-card-content sokal-color-light">
                                      <p class="h2 sokal-m-0">Get Pre-Approved</p>
                                  </div>
                              </div>
                          </a>
                          <!-- Card -->
                          <a href="#"
                              class="sokal-card sokal-inline-flex sokal-w-auto has-border-radius lazyload sokal-relative toggle-search-modal grid-4"
                              :style="{ backgroundImage: `url('https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/353/original/approved.png?1763656691')` }">
                              <div class="sokal-bg-cover"></div>
                              <div
                                  class="sokal-inline-flex sokal-items-start sokal-justify-end sokal-flex-col text-left">
                                  <div class="sokal-card-content sokal-color-light">
                                      <p class="h2 sokal-m-0">Search Inventory</p>
                                  </div>
                              </div>
                          </a>
                      </div>
                  </div>
              </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
  @import '@/assets/styles/sokal_utility_classes_responsive.scss';
</style>

<style>

  #shopping-tools-tiles {
    background-color: var(--sokal-pcd-ford);
    color: #ffffff;
  }

  #shopping-tools-tiles .shopping-tools-super-title {
    color: var(--secondary-color);
    font-size: 1.4rem;
  }

  #shopping-tools-tiles .shopping-tools-title {
    font-size: 3rem;
    color: var(--primary-dark);
  }

  #shopping-tools-tiles .sokal-bg-cover {
    -webkit-backdrop-filter: brightness(0.8);
    backdrop-filter: brightness(0.8);
    -webkit-transition: all 0.2s linear;
    transition: all 0.2s linear;
    border-radius: 10px;
  }

  #shopping-tools-tiles a:hover .sokal-bg-cover,
  #shopping-tools-tiles a:focus .sokal-bg-cover {
    -webkit-backdrop-filter: brightness(0.5);
    backdrop-filter: brightness(0.5);
  }
  #shopping-tools-tiles .sokal-grid {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 10px;
  }

  #shopping-tools-tiles .grid-1 {
    grid-column: 1 / span 2;
    grid-row: 1 / span 2;
  }

  #shopping-tools-tiles .grid-2 {
    grid-column: 3 / span 2;
    grid-row: 1;
  }

  #shopping-tools-tiles .grid-3 {
    grid-column: 3;
    grid-row: 2;
  }

  #shopping-tools-tiles .grid-4 {
    grid-column: 4;
    grid-row: 2;
  }

  #shopping-tools-tiles .sokal-grid .sokal-card {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    min-height: 20em;
  }

  #shopping-tools-tiles .sokal-grid .sokal-card:hover,
  #shopping-tools-tiles .sokal-grid .sokal-card:focus
  #shopping-tools-tiles .sokal-grid .sokal-card:active {
    text-decoration: none;
  }

  @media (max-width: 1199px) {
    #shopping-tools-tiles .sokal-grid {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto;
    }

    #shopping-tools-tiles .grid-1 {
      grid-column: 1 / span 1;
      grid-row: 1;
    }

    #shopping-tools-tiles .grid-2 {
      grid-column: 2 / span 1;
      grid-row: 1;
    }

    #shopping-tools-tiles .grid-3 {
      grid-column: 1;
      grid-row: 2;
    }

    #shopping-tools-tiles .grid-4 {
      grid-column: 2;
      grid-row: 2;
    }
  }

  @media (max-width: 767px) {
    #shopping-tools-tiles .sokal-grid {
      grid-template-columns: 1fr;
    }

    #shopping-tools-tiles .sokal-grid .sokal-card {
      grid-column: 1;
      grid-row: auto;
    }
  }
</style>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>